import Modal from 'components/dom/Modal'
import { render } from 'utils/jsx'

export default (err, {
  log = true,
  stacktrace = true
} = {}) => new Promise(resolve => {
  err = err instanceof Error ? err : new Error(err)
  log && console.error(err)

  render((
    <Modal title='Erreur' tone='error'>
      {err.message || 'Une erreur inconnue est survenue, contactez l\'administrateur.'}
      {stacktrace && <pre class='stacktrace'>{err.stack}</pre>}
    </Modal>
  ), document.body)
})



// WEBPACK FOOTER //
// ./src/controllers/error.js